'use strict';

export const xhrTagAndCategorySearchSuggestions = query => {
    return new Promise((resolve, reject) => {
        const http = new XMLHttpRequest();
        http.responseType = 'json';
        const url = `/kvbm/cat-tag?q=${query}`;
        http.open('GET', url, true);
        http.onreadystatechange = () => {
            if (http.readyState === 4 &&
                http.status === 200
            ) {
                resolve(http);
            } else if (
                http.readyState === 4 &&
                http.status !== 200
            ) {
                reject(http);
            }
        }
        http.send();
    });
};